
import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('user')
import { RInput, RButton, GDPRCheckbox } from '@/components'

export default Vue.extend({
  name: 'CompleteProfile',
  components: {
    RInput,
    RButton,
    gdpr: GDPRCheckbox,
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      gdpr: false,
    }
  },
  methods: {
    async onSignUp() {
      if (!this.gdpr) {
        throw 'No GDPR consent given!'
      }
      const { firstName, lastName } = this
      this.socialSignUp({ firstName, lastName })
    },
    ...mapActions(['socialSignUp', 'ensureProfile', 'logOut']),
  },
  computed: {
    ...mapGetters(['registrationRequest', 'socialRequest', 'user']),
    submitDisabled(): boolean {
      return !this.gdpr
    },
  },
})
